import cloneDeep from "lodash-es/cloneDeep"

import { createResponseTransformer } from "shared/api/createResponseTransformer"
import { serializer } from "shared/api/serializer/serializer"
import { transformJsonApiResponse } from "shared/api/transformJsonApiResponse"
import { Floor } from "shared/types/Floor"
import { FloorsAPIType } from "shared/types/Project"

import { transformProjectChildren } from "entities/projects/graphql/projectResponseTransformer"

export function transformFloor(floor: Floor): Floor {
  return { ...floor, children: transformProjectChildren(floor.children) }
}

export const floorResponseTransformer = createResponseTransformer(json => {
  // json-api-serializer declares `deserialize` as `any`; the floor shape is
  // asserted once here so nothing downstream has to.
  const deserialized = cloneDeep(
    serializer.deserialize(FloorsAPIType, transformJsonApiResponse(json))
  ) as Floor
  return transformFloor(deserialized)
})
